import React from 'react';
import './Page.css';

function PrivacyPolicy() {
  return (
    <div className="page-container">
      <div className="page-content">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: December 2024</p>

        <section className="page-section">
          <h2>1. Information We Collect</h2>
          <p>
            We collect information that you provide directly to us, including:
          </p>
          <ul>
            <li>Name and contact information (email address, phone number)</li>
            <li>Payment information (processed securely through Indian payment gateways like Razorpay/Paytm)</li>
            <li>Course enrollment and progress data</li>
            <li>Project submissions and assessments</li>
            <li>Communication history with our support team</li>
            <li>Device and location information (to comply with Indian regulations)</li>
          </ul>
        </section>

        <section className="page-section">
          <h2>2. How We Use Your Information</h2>
          <p>
            We use the information we collect to:
          </p>
          <ul>
            <li>Provide, maintain, and improve our services</li>
            <li>Process course enrollments and issue certificates</li>
            <li>Send course updates, notifications, and support messages</li>
            <li>Respond to your inquiries and provide customer support in your preferred language</li>
            <li>Analyze usage patterns to enhance user experience for Indian learners</li>
            <li>Comply with Indian legal obligations and protect our rights</li>
            <li>Prevent fraud and ensure platform security</li>
          </ul>
        </section>

        <section className="page-section">
          <h2>3. Information Sharing</h2>
          <p>
            We do not sell, trade, or rent your personal information to third parties. 
            As an Indian startup, we keep your data within India. We may share your 
            information only in the following circumstances:
          </p>
          <ul>
            <li>With Indian service providers who assist in operating our platform</li>
            <li>When required by Indian law or to protect our legal rights</li>
            <li>With your explicit consent</li>
            <li>In connection with a business transfer or acquisition</li>
          </ul>
        </section>

        <section className="page-section">
          <h2>4. Data Security and Storage</h2>
          <p>
            We implement appropriate technical and organizational security measures to 
            protect your personal information. All data is stored on secure servers located 
            in India, complying with Indian data protection regulations. However, no method 
            of transmission over the internet is 100% secure.
          </p>
        </section>

        <section className="page-section">
          <h2>5. Cookies and Tracking Technologies</h2>
          <p>
            We use cookies and similar tracking technologies to enhance your experience 
            on our platform. These technologies help us understand how you use our 
            services and improve our offerings. You can control cookie settings through 
            your browser.
          </p>
        </section>

        <section className="page-section">
          <h2>6. Your Rights</h2>
          <p>
            Under Indian data protection laws, you have the right to:
          </p>
          <ul>
            <li>Access the personal information we hold about you</li>
            <li>Request correction of inaccurate information</li>
            <li>Request deletion of your personal information</li>
            <li>Opt-out of marketing communications</li>
            <li>Request a copy of your data in a portable format</li>
            <li>Withdraw consent for data processing</li>
          </ul>
        </section>

        <section className="page-section">
          <h2>7. Data Retention</h2>
          <p>
            We retain your personal information for as long as necessary to provide our 
            services and comply with Indian legal obligations. Course completion data and 
            certificates are retained indefinitely for verification purposes and to maintain 
            records as required by Indian education regulations.
          </p>
        </section>

        <section className="page-section">
          <h2>8. Children's Privacy</h2>
          <p>
            Our services are intended for individuals who are 13 years or older. With 
            parental consent, we may provide services to minors. We comply with Indian 
            laws regarding children's online privacy and protection.
          </p>
        </section>

        <section className="page-section">
          <h2>9. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time to reflect changes in 
            Indian data protection laws. We will notify you of any significant changes 
            by posting the new policy on this page and updating the "Last Updated" date.
          </p>
        </section>

        <section className="page-section">
          <h2>10. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy or our data practices, 
            please contact us at care@extrabyte.in or through our Contact Us page.
          </p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
